(function($, undefined) {
	
	'use strict';
	var isLoggedIn = false;
	var isMobile = false;
	var win = $(window);
	var winWidth;
	var winHeight;
	
	var header;
	var navItems;
	
	var toggleMenuBtn;
	
	
	var toggleScroll = function () {
		var diff;
		
		if ($('body').hasClass('no-scroll')) {
			$('body').removeClass('no-scroll');
			diff = 0;
		} else {
			var w1 = win.width();
			$('body').addClass('no-scroll');
			var w2 = win.width();
			diff = w2 - w1;
		}
		
		changeScrollDiff(diff);
	};
	
	var changeScrollDiff = function (diff) {
		$('.js-scroll-padding').css('padding-right', diff + 'px');
		$('.js-scroll-right').css('right', diff + 'px');
	};
	
	var onClickMenuToggle = function () {
		if (!!$('body').hasClass('menu-open')) {
			var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
			$('body').removeClass('menu-open');
			
			header.on(transitionEnd, function(e) {
				$('body').removeClass('no-scroll');
				changeScrollDiff(0);
				$(this).off(e);
			});
		} else {
			var target = 0;
			
			if ($('.site-header').css('scroll-y') !== 'fixed' && $('.site-header').offset().top > 0) {
				target = $('.site-header').offset().top;
			}
			
			if (win.scrollTop() <= $('.site-header').offset().top) {
				$('html').animate({scrollTop: target}, 300);
				$('body').animate({scrollTop: target}, 300, function () {
					openMenu();
				});
			} else {
				openMenu();
			}
		}
	};
	
	var openMenu = function () {
		$('body').addClass('menu-open');
		toggleScroll();
	};
	
	var closeMenu = function () {
		if ($('body').hasClass('menu-open')) {
			$('body').removeClass('menu-open');
			toggleScroll();
		}
	};
	
	var updateNavSelected = function (page) {
		navItems.removeClass('selected');
		var handleObj = $('.main-content ' + page);
		var handle = handleObj.attr('data-page-nav');
		
		navItems.each(function () {
			var t = $(this);
			
			if (t.data('pageNav') === handle) {
				t.addClass('selected');
			}
		});
	};
	
	var init = function () {
		winWidth = win.width();
		winHeight = win.height();
		$('body').removeClass('no-scroll');
		
		header = $('.site-header');
		navItems = $('.nav-item-link', header);
		
		toggleMenuBtn = $('.site-header-menu-toggle-btn', header);
		
		
		if($('body').hasClass('is-logged-in')) {
			isLoggedIn = true;
		}
		
		toggleMenuBtn.on('click', onClickMenuToggle);
		navItems.on('click', closeMenu);
		
		win.scroll(function () {
			
		});
		
		win.resize(function() {
			if (win.width() != winWidth) {
				if ($('body').hasClass('menu-open')) {
					toggleMenuBtn.trigger('click');
				}
				winHeight = win.height();
				winWidth = win.width();
			}
		});
	};
	
	
	$(init);
	
})(jQuery);
